import React, {
  FC,
  useMemo,
  useState,
} from 'react';
import MetricsCardWithRank from '../MetricsCardWithRankWrap';
import { Card, Col, Row } from 'tea-component';
import { isEmpty } from 'lodash-es';
import MetricsCard from '@/pages/strategic/components/MetricsCard';
import cls from 'classnames';
import './index.scss';
import MetricsCardDod from '@/pages/dashboard/components/MetricsCardDod';
import MetricsCardWrapTitle from '@sg/components/MetricsCardWrap/MetricsCardWrapTitle';
import MetricsCardValue from '@/pages/dashboard/components/MetricsCardValue';
import {
  configFunc,
  getMetricDataByKey,
  getPlatFormData,
  transformDataSource,
  transformTimelineData,
} from '../../../../utils';
// import Loading from '@intelligence/components/Loading';
import MetricsTrendChart from '@sg/components/MetricsTrendChart';
import { METRIC_NAME_LIST, convertMetricsToArray } from '../../../LiveDownload/utils';
import ChartBubble from '@intelligence/components/ChartBubble';
import { useIntl } from 'umi';
import { createBtnPoint, SGBuriedBtnPoint, LiveTitlesTab } from '@/pages/strategic/utils/buriedPoint';
import PlainText from '@sg/components/PlainText';
import { EDIT_PAGE_KEY_MAP } from '@/pages/strategic/hooks/useAutoSaveParams';
import { getButtonPermission } from '@sg/_config/permission';
import { usePermissionReady } from '@sg/hooks/usePermissionReady';
import EventsTimelineCard from '../EventsTimelineCard';
import { getCurrencySymbol, resolveLiveTitleCurrencyCode } from '@sg/pages/StudioManagement/LiveTitles/utils/currencyRules';
interface Props {
  summaryData?: any;
  timeLineData?: any;
  eventsData?: any;
  eventsLoading?: boolean;
  selectedDate?: any;
  loading?: boolean;
  metricTipsData?: any;
  switcher?: string;
  setSwitcher?: (val: string) => void;
  studio?: {
    name: string;
    unified_id: string;
  };
  /** PlainText note API params (no logical_flag; date comes from notesSelectedMonth). */
  notesParams?: {
    game_title: string;
    source: string;
  };
  /** Range end month from top filter, aligned with PlainText selectedMonth. */
  notesSelectedMonth?: import('moment').Moment | null;
  notesMaxDataTime?: string | null;
  [key: string]: unknown;
}

export const inDevProDataAnalyticsKey = {
  spend_to_date: {
    textCn: 'Spend to Date ($)',
    textEn: 'Spend to Date ($)',
    definitionKey: 'dbs_spend_to_date_definition',
    definition: '',
    tabKey: 'spend_to_date',
    metric: 'spend_to_date',
    typeText: 'Total Spend',
    metricType: 'Total Spend',
    source: 'Finance',
    update_frequency: 'Monthly',
    level: 1,
    valueType: 'value_date',
    width: 180,
  },
  total_dev_cost: {
    textCn: 'Total Dev Cost ($)',
    textEn: 'Total Dev Cost ($)',
    tabKey: 'total_dev_cost',
    metric: 'total_dev_cost',
    metric1: 'total_dev_cost_estimated',
    metric2: 'total_dev_cost_approved',
    definitionKey: 'dbs_studio_in_dev_project_budget_to_next_milestone_definition',
    definition: '',
    typeText: 'Total Spend',
    metricType: 'Total Spend',
    source: 'Finance',
    update_frequency: 'As Needed',
    level: 1,
    valueType: 'value_date_double',
  },
  headcount_actual: {
    textCn: 'Headcount Actual',
    textEn: 'Headcount Actual',
    tabKey: 'headcount_actual',
    metric: 'headcount_actual',
    definitionKey: 'dbs_studio_in_dev_project_actual_definition',
    definition: '',
    typeText: 'Headcount',
    metricType: 'Headcount',
    source: 'PMI',
    update_frequency: 'Monthly',
    level: 1,
    valueType: 'value_mom',
    width: 180,
  },
  hc_planned: {
    textCn: 'HC Planned',
    textEn: 'HC Planned',
    tabKey: 'hc_planned',
    metric: 'hc_planned',
    metric1: 'hc_planned_current',
    metric2: 'hc_planned_next',
    definitionKey: '',
    definitionKey1: 'dbs_studio_in_dev_project_planned_current_milestone_definition',
    definitionKey2: 'dbs_studio_in_dev_project_planned_next_milestone_definition',
    definition: '',
    typeText: 'Headcount',
    metricType: 'Headcount',
    source: 'Finance',
    update_frequency: 'Monthly',
    level: 1,
    valueType: 'value_name_double',
    width: 190,
  },
  y_copy_sales: {
    textCn: 'Y1~Y3 Copy Sales Forecast',
    textEn: 'Y1~Y3 Copy Sales Forecast',
    tabKey: 'y_copy_sales',
    metric: 'y_copy_sales',
    metric1: 'y1_copy_sales',
    metric2: 'y2_copy_sales',
    metric3: 'y3_copy_sales',
    definitionKey: '',
    definitionKey1: '',
    definitionKey2: '',
    definitionKey3: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 1,
    valueType: 'value_name_three',
    width: 180,
  },
  y_gross_revenue: {
    textCn: 'Y1~Y3 Gross Revenue Forecast ($)',
    textEn: 'Y1~Y3 Gross Revenue Forecast ($)',
    tabKey: 'y_gross_revenue',
    metric: 'y_gross_revenue',
    metric1: 'y1_gross_revenue',
    metric2: 'y2_gross_revenue',
    metric3: 'y3_gross_revenue',
    definitionKey: '',
    definitionKey1: '',
    definitionKey2: '',
    definitionKey3: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 1,
    valueType: 'value_name_three',
    width: 200,
  },
  ytm_total_project_cost: {
    textCn: 'YTM Total Project Cost ($)',
    textEn: 'YTM Total Project Cost ($)',
    tabKey: 'ytm_total_project_cost',
    metric: 'ytm_total_project_cost',
    metric1: 'total_dev_cost_estimated',
    metric2: 'total_dev_cost_approved',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 1,
    valueType: 'value_mom',
    width: 260,
  },
  ytm_dev_cost: {
    textCn: 'Dev Cost ($)',
    textEn: 'Dev Cost ($)',
    tabKey: 'ytm_dev_cost',
    metric: 'ytm_dev_cost',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 2,
    valueType: 'value_mom',
    width: 160,
  },
  ytm_rd_staff_cost: {
    textCn: 'R&D Staff Cost ($)',
    textEn: 'R&D Staff Cost ($)',
    tabKey: 'ytm_rd_staff_cost',
    metric: 'ytm_rd_staff_cost',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 3,
    valueType: 'value_mom',
    width: 200,
  },
  ytm_outsourcing_cost: {
    textCn: 'Outsourcing ($)',
    textEn: 'Outsourcing ($)',
    tabKey: 'ytm_outsourcing_cost',
    metric: 'ytm_outsourcing_cost',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 3,
    valueType: 'value_mom',
    width: 170,
  },
  ytm_other_rd_cost: {
    textCn: 'Other R&D ($)',
    textEn: 'Other R&D ($)',
    tabKey: 'ytm_other_rd_cost',
    metric: 'ytm_other_rd_cost',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 3,
    valueType: 'value_mom',
    width: 160,
  },
  ytm_ga_overheads: {
    textCn: 'G&A Overheads ($)',
    textEn: 'G&A Overheads ($)',
    tabKey: 'ytm_ga_overheads',
    metric: 'ytm_ga_overheads',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 3,
    valueType: 'value_mom',
    width: 200,
  },
  ytm_vgtr: {
    textCn: 'VGTR ($)',
    textEn: 'VGTR ($)',
    tabKey: 'ytm_vgtr',
    metric: 'ytm_vgtr',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 3,
    valueType: 'value_mom',
    width: 120,
  },
  ytm_mkt_cost: {
    textCn: 'Mkt Cost ($)',
    textEn: 'Mkt Cost ($)',
    tabKey: 'ytm_mkt_cost',
    metric: 'ytm_mkt_cost',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 2,
    valueType: 'value_mom',
    width: 160,
  },
  ytm_other_cost: {
    textCn: 'Other Cost ($)',
    textEn: 'Other Cost ($)',
    tabKey: 'ytm_other_cost',
    metric: 'ytm_other_cost',
    definitionKey: '',
    definition: '',
    typeText: 'Life Cycle Financial Forecast',
    metricType: '',
    source: '',
    update_frequency: '',
    level: 2,
    valueType: 'value_mom',
    width: 160,
  },
};

export const topModalKey = {
  gross_revenue: {
    // textCn: '总收入($)', // 原代码：暂时写死成英文
    textCn: 'Total Gross Revenue($)', // 暂时写死成英文
    textEn: 'Total Gross Revenue($)',
    tabKey: 'gross_revenue',
    metricType: 'total',
  },
  gross_base_sales: {
    // textCn: '基础销售收入', // 原代码：暂时写死成英文
    textCn: 'Base Sales Revenue', // 暂时写死成英文
    textEn: 'Base Sales Revenue',
    tabKey: 'gross_revenue',
    metricType: 'split',
  },
  gross_gaas_sales: {
    // textCn: '游戏即服务收入', // 原代码：暂时写死成英文
    textCn: 'GAAS Revenue', // 暂时写死成英文
    textEn: 'GAAS Revenue',
    tabKey: 'gross_revenue',
    metricType: 'split',
  },
  net_revenue: {
    // textCn: '净收入($)', // 原代码：暂时写死成英文
    textCn: 'Net Revenue($)', // 暂时写死成英文
    textEn: 'Net Revenue($)',
    tabKey: 'net_revenue',
    metricType: 'total',
  },
  net_base_sales: {
    // textCn: '基础销售收入', // 原代码：暂时写死成英文
    textCn: 'Base Sales Revenue', // 暂时写死成英文
    textEn: 'Base Sales Revenue',
    tabKey: 'net_revenue',
    metricType: 'split',
  },
  net_gaas_sales: {
    // textCn: '游戏即服务收入', // 原代码：暂时写死成英文
    textCn: 'GAAS Revenue($)', // 暂时写死成英文
    textEn: 'GAAS Revenue($)',
    tabKey: 'net_revenue',
    metricType: 'split',
  },
  unit_sales: {
    // textCn: '销量', // 原代码：暂时写死成英文
    textCn: 'Unit Sales', // 暂时写死成英文
    textEn: 'Unit Sales',
    tabKey: 'unit',
    metricType: 'total',
  },
  base_sales: {
    // textCn: '基础销量', // 原代码：暂时写死成英文
    textCn: 'Base Sales', // 暂时写死成英文
    textEn: 'Base Sales',
    metricType: 'split',
  },
  dlc_sales: {
    // textCn: 'DLC 销量', // 原代码：暂时写死成英文
    textCn: 'DLC Sales', // 暂时写死成英文
    textEn: 'DLC Sales',
    metricType: 'split',
  },
};

export const centerLeftModalKey = {
  mau: {
    // textCn: '月活跃用户数', // 原代码：暂时写死成英文
    textCn: 'MAU', // 暂时写死成英文
    textEn: 'MAU',
  },
  avg_dau: {
    // textCn: '平均日活跃用户数', // 原代码：暂时写死成英文
    textCn: 'AVG.DAU', // 暂时写死成英文
    textEn: 'AVG.DAU',
  },
  pcu: {
    // textCn: '峰值同时在线人数', // 原代码：暂时写死成英文
    textCn: 'PCU', // 暂时写死成英文
    textEn: 'PCU',
  },
};

export const centerRightModalKey = {
  new_users: {
    // textCn: '新增用户', // 原代码：暂时写死成英文
    textCn: 'New Users', // 暂时写死成英文
    textEn: 'New Users',
  },
  returned_users: {
    // textCn: '回流用户', // 原代码：暂时写死成英文
    textCn: 'Returned Users', // 暂时写死成英文
    textEn: 'Returned Users',
  },
  retained_users: {
    // textCn: '留存用户', // 原代码：暂时写死成英文
    textCn: 'Retained Users', // 暂时写死成英文
    textEn: 'Retained Users',
  },
};

export const footerModalKey = {
  payers: {
    // textCn: '付费用户', // 原代码：暂时写死成英文
    textCn: 'Payers', // 暂时写死成英文
    textEn: 'Payers',
  },
  payers_ratio: {
    // textCn: '付费用户占比(%)', // 原代码：暂时写死成英文
    textCn: 'Payer Ratio(%)', // 暂时写死成英文
    textEn: 'Payer Ratio(%)',
  },
  arpu: {
    // textCn: '每用户平均收入($)', // 原代码：暂时写死成英文
    textCn: 'ARPU($)', // 暂时写死成英文
    textEn: 'ARPU($)',
  },
  arppu: {
    // textCn: '每付费用户平均收入($)', // 原代码：暂时写死成英文
    textCn: 'ARPPU($)', // 暂时写死成英文
    textEn: 'ARPPU($)',
  },
};

// Footer cards use fixed metric slots (not array index) so missing payers_ratio/arppu
// does not shift payers/arpu into the wrong column.
const FOOTER_CARD_GROUPS: Array<[string, string]> = [
  ['payers', 'payers_ratio'],
  ['arpu', 'arppu'],
];

export const centerModalKey = {
  mau: {
    // textCn: '月活跃用户数', // 原代码：暂时写死成英文
    textCn: 'MAU', // 暂时写死成英文
    textEn: 'MAU',
  },
  avg_dau: {
    // textCn: '平均日活跃用户数', // 原代码：暂时写死成英文
    textCn: 'AVG.DAU', // 暂时写死成英文
    textEn: 'AVG.DAU',
  },
  pcu: {
    // textCn: '峰值同时在线人数', // 原代码：暂时写死成英文
    textCn: 'PCU', // 暂时写死成英文
    textEn: 'PCU',
  },
  new_users: {
    // textCn: '新增用户', // 原代码：暂时写死成英文
    textCn: 'New Users', // 暂时写死成英文
    textEn: 'New Users',
  },
  returned_users: {
    // textCn: '回流用户', // 原代码：暂时写死成英文
    textCn: 'Returned Users', // 暂时写死成英文
    textEn: 'Returned Users',
  },
  retained_users: {
    // textCn: '留存用户', // 原代码：暂时写死成英文
    textCn: 'Retained Users', // 暂时写死成英文
    textEn: 'Retained Users',
  },
};

const defaultCarts = () => ({
  showConfig: {
    showLineChart: true,
    showBubbleTitle: true,
  },
  isOnlyChart: true,
  filterVal: {
    timeType: 'Month'
  },
  setOtherConfigFunc: configFunc,
  componentMetrics: [
    {
      metricKey: 'current',
      reqMetricKey: 'current',
      formatRule: 'thousands2Decimal',
      isCompare: true,
      nameEn: 'This Month',
      nameCn: 'This Month',
      compareToolTipNameEn: 'Same Month Last Year',
      compareToolTipNameCn: 'Same Month Last Year',
    },
  ],
});
const LiveCardWithRank: FC<Props> = ({
  summaryData,
  timeLineData,
  eventsData,
  eventsLoading,
  selectedDate,
  loading,
  metricTipsData,
  switcher,
  setSwitcher,
  studio,
  notesParams,
  notesSelectedMonth,
  notesMaxDataTime,
}) => {
  const { locale } = useIntl(); // 原代码：动态获取locale
  const { formatMessage } = useIntl();
  const { ready: permissionReady } = usePermissionReady();
  const buttonPermission = useMemo(() => ({
    notes: getButtonPermission('studio_liveTitles_notes'),
  }), [permissionReady]);
  const studioInfo = useMemo(() => {
    const studioName = studio?.name || 'Unknown';
    const studioId = studio?.unified_id || '';
    return `Studio: ${studioName}${studioId ? ` (ID: ${studioId})` : ''}`;
  }, [studio?.name, studio?.unified_id]);
  // resolveLiveTitleCurrencyCode({ unifiedId, gameTitle }):
  // input stable project keys -> output normalized code ('USD' | 'CNY'),
  // with unifiedId mapping preferred and gameTitle as fallback.
  // getCurrencySymbol(code): converts code to display symbol ('$' | '¥').
  const currencySymbol = useMemo(() => {
    const currencyCode = resolveLiveTitleCurrencyCode({
      unifiedId: studio?.unified_id,
      gameTitle: studio?.name,
    });
    return getCurrencySymbol(currencyCode);
  }, [studio?.name, studio?.unified_id]);
  const topModalKeyWithCurrency = useMemo<Record<string, any>>(() => ({
    ...topModalKey,
    gross_revenue: {
      ...topModalKey.gross_revenue,
      textCn: `Total Gross Revenue(${currencySymbol})`,
      textEn: `Total Gross Revenue(${currencySymbol})`,
    },
  }), [currencySymbol]);
  const footerModalKeyWithCurrency = useMemo<Record<string, any>>(() => ({
    ...footerModalKey,
    arpu: {
      ...footerModalKey.arpu,
      textCn: `ARPU(${currencySymbol})`,
      textEn: `ARPU(${currencySymbol})`,
    },
    arppu: {
      ...footerModalKey.arppu,
      textCn: `ARPPU(${currencySymbol})`,
      textEn: `ARPPU(${currencySymbol})`,
    },
  }), [currencySymbol]);

  const {
    topModalData,
    centerModalData,
    // centerLeftModalData,
    // centerRightModalData,
    footerModalData,
    topModalLineData,
    // centerLeftModalLineData,
    // centerRightModalLineData,
    centerModalLineData,
    footerModalLineData,
    lineData,
  } = useMemo(() => {
    let topModalData;
    let topModalLineData;
    let footerModalData;
    let footerModalLineData;
    let centerModalData;
    let centerModalLineData;
    // let centerLeftModalData;
    // let centerRightModalData;
    // let centerLeftModalLineData;
    // let centerRightModalLineData;

    const lineData = timeLineData?.list?.[0]?.metrics;
    const dataSource = !isEmpty(summaryData?.list?.[0]?.metrics) ? summaryData?.list?.[0]?.metrics : convertMetricsToArray(METRIC_NAME_LIST);
    if (dataSource) {
      const filterData = (keyMap: Record<string, any>) =>
        dataSource.filter((item) => keyMap[item.metric]);
      topModalData = filterData(topModalKeyWithCurrency);
      footerModalData = filterData(footerModalKeyWithCurrency);
      // 2.0 live title
      centerModalData = filterData(centerModalKey);
      // 3.0 live title (removed)
      // centerLeftModalData = filterData(centerLeftModalKey);
      // centerRightModalData = filterData(centerRightModalKey);

      topModalLineData = transformDataSource({
        dataSource: topModalData,
        mapKey: topModalKeyWithCurrency,
        metricTipsData,
      });
      footerModalLineData = transformDataSource({
        dataSource: footerModalData,
        mapKey: footerModalKeyWithCurrency,
        metricTipsData,
      });
      centerModalLineData = transformDataSource({
        dataSource: centerModalData,
        mapKey: centerModalKey,
        metricTipsData,
      });
      // centerLeftModalLineData = transformDataSource({
      //   dataSource: centerLeftModalData,
      //   mapKey: centerLeftModalKey,
      //   metricTipsData,
      // });
      // centerRightModalLineData = transformDataSource({
      //   dataSource: centerRightModalData,
      //   mapKey: centerRightModalKey,
      //   metricTipsData,
      // });
    }
    return {
      topModalData,
      centerModalData,
      // centerLeftModalData,
      // centerRightModalData,
      footerModalData,
      topModalLineData,
      centerModalLineData,
      // centerLeftModalLineData,
      // centerRightModalLineData,
      footerModalLineData,
      lineData,
    };
  }, [footerModalKeyWithCurrency, metricTipsData, summaryData?.list, timeLineData?.list, topModalKeyWithCurrency]);

  const modifyCenterModalData = useMemo(() => {
    const formatter = (item) => {
      // 1. 根据key获取对应的timeline数据
      const timelineData = getMetricDataByKey(lineData, item.key);
      // 2. 转换数据格式
      const metricData = transformTimelineData(timelineData);
      return {
        ...item,
        metricData,
        metricsChart: (
          <div style={{ width: '100%', marginLeft: '20px' }} >
            {/* className={'dbd-metrics-card__flex'} */}
            <MetricsTrendChart
              {...{
                height: '75',
                titleEn: item.titleEn,
                titleCn: item.titleCn,
                metricData,
                ...defaultCarts(),
              }}
            />
          </div>
        ),
      };
    };
    return centerModalLineData?.map((item) => formatter(item));
    // return {
    //   centerLeft: centerLeftModalLineData?.map((item) => formatter(item)),
    //   centerRight: centerRightModalLineData?.map((item) => formatter(item)),
    // };
  }, [centerModalLineData, lineData]);
  const modifyTopModalData = useMemo(() => {
    if (isEmpty(topModalLineData)) {
      return [];
    }
    const oneLineData = topModalLineData
      ?.slice(0, 6)
      ?.filter((item) => topModalKeyWithCurrency[item?.key]?.tabKey === switcher);
    const splitData = [oneLineData, topModalLineData?.slice(6)];
    const enhancedDatList = splitData?.map((item, index) => {
      // 1. 根据key获取对应的timeline数据
      const timelineData = getMetricDataByKey(lineData, item?.[0]?.key);
      // 2. 转换数据格式
      const metricData = transformTimelineData(timelineData);
      const rankData = getPlatFormData(
        summaryData?.list?.[0]?.os_metrics,
        item?.[0]?.key,
      );
      return {
        ...(item?.[0] || {}),
        rankData,
        metricData: item,
        metricsChart: (
          <div className={'dbd-metrics-card__flex'} style={{ marginRight: '20px' }}>
            <MetricsTrendChart
              {...{
                ...defaultCarts(),
                height: '80',
                titleEn: topModalKeyWithCurrency[item?.[0]?.key]?.textEn,
                titleCn: topModalKeyWithCurrency[item?.[0]?.key]?.textCn,
                metricData,
              }}
            />
          </div>
        ),
      };
    });
    return enhancedDatList;
  }, [lineData, summaryData?.list, switcher, topModalKeyWithCurrency, topModalLineData]);
  const footerData = useMemo(() => {
    if (isEmpty(footerModalLineData)) {
      return [];
    }

    // Build a metric-key lookup first; backend may omit optional footer metrics.
    const summaryDataByKey = footerModalLineData.reduce<Record<string, any>>(
      (acc, task) => {
        // 1. 根据key获取对应的timeline数据
        const timelineData = getMetricDataByKey(lineData, task.key);
        // 2. 转换数据格式
        const metricData = transformTimelineData(timelineData);
        acc[task.key] = {
          ...task,
          tips: locale === 'zh-CN' ? task?.tipsCn : task?.tipsEn,
          title: locale === 'zh-CN' ? task?.titleCn : task?.titleEn,
          metricData: {
            filterVal: {
              timeType: 'Month',
            },
            componentMetrics: [
              {
                metricKey: 'current',
                reqMetricKey: 'current',
                formatRule: 'thousands2Decimal',
                isCompare: true,
                nameEn: 'This Month',
                nameCn: 'This Month',
                compareToolTipNameEn: 'Same Month Last Year',
                compareToolTipNameCn: 'Same Month Last Year',
              },
            ],
            height: '120',
            titleEn: footerModalKeyWithCurrency[task?.key]?.textEn,
            titleCn: footerModalKeyWithCurrency[task?.key]?.textCn,
            metricData,
          },
        };
        return acc;
      },
      {},
    );

    // Place each card by metric key: [primary(left), secondary(right)].
    return FOOTER_CARD_GROUPS.map(([primaryKey, secondaryKey]) => ({
      primaryKey,
      metrics: [summaryDataByKey[primaryKey], summaryDataByKey[secondaryKey]],
    })).filter(({ metrics }) => metrics[0] || metrics[1]);
  }, [footerModalKeyWithCurrency, footerModalLineData, lineData, locale]);
  return (
    <div className='dbs-live-titles'>
      <Row>
        <>
          {modifyTopModalData?.map((task: any, index: any) => (
            <Col span={8} key={index} className='dbs-live-titles__top-metric-col'>
              <MetricsCardWithRank
                overlayClassName="dbs-metrics-card-tips-bubble"
                {...task}
                className={cls(task?.className, 'dbs-live-titles__top-metric-card')}
                {...{
                  contentHeader: index === 0 && (
                    <MetricSwitcher
                      active={switcher}
                      onChange={(value) => {
                        // Track buried point for Metric Switcher change
                        const metricType = value === 'gross_revenue' ? 'Gross' : 'Net';
                        const btnPoint = createBtnPoint(
                          LiveTitlesTab,
                          value === 'gross_revenue' ? 'metricSwitcherGross' : 'metricSwitcherNet',
                          `Metric Switcher - ${metricType}`
                        );
                        if (btnPoint) {
                          SGBuriedBtnPoint(btnPoint);
                        }
                        setSwitcher(value);
                      }}
                      lang={locale === 'zh-CN' ? 'zh' : 'en'}
                    />
                  ),
                }}
              />
            </Col>
          ))}
          <Col span={8} className='dbs-live-titles__top-right-col'>
            <div className='dbs-live-titles__top-right-stack'>
              <div className='dbs-live-titles__events-card-wrap'>
                <EventsTimelineCard
                  eventsData={eventsData}
                  loading={eventsLoading}
                  selectedDate={selectedDate}
                />
              </div>
              <div className='dbs-live-titles__notes-card-wrap'>
                <PlainText
                  className='dbs-live-plaintext'
                  key={`plaintext-${studio?.unified_id}`}
                  title={formatMessage({ id: 'dbs_notes' })}
                  url="/api/v1/mgmt_pc/note/get"
                  editUrl="/api/v1/mgmt_pc/note/update"
                  tinyEditorHeight={160}
                  params={notesParams}
                  showDatePicker={false}
                  selectedMonth={notesSelectedMonth ?? undefined}
                  maxDataTime={notesMaxDataTime ?? undefined}
                  showTimeInTitle={true}
                  editable={true}
                  userPermissions={{ canEdit: buttonPermission.notes }}
                  autoSavePageKey={EDIT_PAGE_KEY_MAP.studio_live_notes}
                  allowFileUpload={true}
                  uploadDomain="mgmt/studio/live_titles/notes"
                  cosConfigDomain="mgmt/studio/live_titles/notes"
                  onEditClick={(type) => {
                    const extInfo = type === 'Add Content Link'
                      ? `Notes Edit - Add Content Link - ${studioInfo}`
                      : `Notes Edit - Edit Button - ${studioInfo}`;
                    const btnPoint = createBtnPoint(
                      LiveTitlesTab,
                      'notesEdit',
                      extInfo
                    );
                    if (btnPoint) {
                      SGBuriedBtnPoint(btnPoint);
                    }
                  }}
                />
              </div>
            </div>
          </Col>
        </>
        {/* 2.0 Live Title format (its 2 row) */}
        <>
          {modifyCenterModalData?.map((task, index) => (
            <Col span={task?.span || 8} key={index} >
              <MetricsCard key={task.textEn} {...task} overlayClassName='dbs-metrics-card-tips-bubble' />
            </Col>
          ))}
        </>
        {/* 3.0 Live Title format (its 2 column) */}
        {/* MAU... card */}
        {/* <Col span={12} className='dbp-metrics-card__mix'>
        {modifyCenterModalData?.centerLeft?.map((task, index) => (
          <MetricsCard key={task.textEn} {...task} />
        ))}
      </Col> */}
        {/* New Users... card */}
        {/* <Col span={12} className='dbp-metrics-card__mix'>
        {modifyCenterModalData?.centerRight?.map((task, index) => (
          <MetricsCard key={task.textEn} {...task} />
        ))}
      </Col> */}
        <>
          {footerData?.map(({ primaryKey, metrics }) => (
            <Col span={12} key={primaryKey}>
              <Card>
                <Card.Body>
                  <div className="dbs-metrics-card-with-rank__right">
                    {/* Left: primary metric (payers / arpu) */}
                    <StatsCardWithComparison
                      {...{
                        list: metrics?.[0] ? [metrics[0]] : [],
                      }}
                      overlayClassName="dbs-metrics-card-tips-bubble"
                    />
                    {/* Chart only follows the left primary metric */}
                    {metrics?.[0] ? (
                      <div className={'dbd-metrics-card__flex dbd-live-metrics-card__flex—tips'} style={{ margin: '40px 40px 0 40px', marginLeft: '30px' }}>
                        <MetricsTrendChart
                          {...(metrics[0]?.metricData || {})}
                          {...(defaultCarts() || {})}
                          height={80}
                        />
                      </div>
                    ) : null}
                    {/* Right: secondary metric (payers_ratio / arppu); hidden when API omits it */}
                    <div className="overlay-card-content-right">
                      <StatsCardWithComparison
                        {...{
                          list: metrics?.[1] ? [metrics[1]] : [],
                        }}
                        overlayClassName="dbs-metrics-card-tips-bubble"
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </>
      </Row>

    </div>
  );
};

export default LiveCardWithRank;

export const StatsCardWithComparison = ({ list = [], className, overlayClassName }: { list: any[]; className?: string; overlayClassName?: string }) => {
  if (isEmpty(list)) return null;
  return (
    <div className='dbs-etrics-card-multi__row'>
      <div
        className={cls(className, 'dbp-metrics-card-multi__row margin-t-30 dbs-metrics-card-multi__row')}
      >
        {list?.map((task) => {
          const {
            title,
            titleEn,
            tipsEn,
            definition,
            source,
            updateTime,
            value,
            tips,
            formatRule = 'db_bmk00',
            emptyValue = '-',
            dodData,
            isIconTips,
            className = '',
            isSubTitle = false,
          } = task || {};
          return (
            <div className="overlay-card-content" key={task?.value}>
              <div
                className={cls({
                  'dbg-live-card__item-sub-title': isSubTitle,
                })}
              >
                <MetricsCardWrapTitle
                  {...{
                    title: title || titleEn,
                    isIconTips,
                    tips: tips || tipsEn,
                    definition,
                    source,
                    updateTime,
                    className,
                    overlayClassName,
                    AWidth: 450,
                  }}
                />
              </div>
              <div style={{ marginBottom: '10px' }}>
                <MetricsCardValue {...{ value, formatRule, emptyValue }} />
              </div>
              <div>
                <MetricsCardDod data={dodData} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

/**
 * 指标项类型定义
 */
interface MetricItem {
  value: string; // 选项值
  label: string; // 中文标签
  labelEn: string; // 英文标签
}

/**
 * 组件属性类型
 */
interface MetricSwitcherProps {
  metrics?: MetricItem[]; // 可配置的指标项数组
  active?: string; // 默认选中的指标值
  onChange?: (value: string) => void; // 切换回调
  lang?: 'zh' | 'en'; // 语言设置
}

const MetricSwitcher = ({
  metrics = [
    // { value: 'gross_revenue', label: '总计', labelEn: 'Gross' }, // Correct one
    // { value: 'net_revenue', label: '净额', labelEn: 'Net' }, // Correct one
    { value: 'gross_revenue', label: 'Gross', labelEn: 'Gross' }, // Temporary method to disable CN version
    { value: 'net_revenue', label: 'Net', labelEn: 'Net' }, // Temporary method to disable CN version
  ],
  active,
  onChange,
  lang = 'en',
}: MetricSwitcherProps) => {
  const handleClick = (value: string) => {
    onChange?.(value);
  };

  return (
    <div className="dbs-metrics-card-with-rank__right-tab">
      {metrics.map((metric) => (
        <div
          className={cls('dbs-metrics-card-with-rank__right-tab-item', {
            'dbs-metrics-card-with-rank__right-tab-item-active':
              active === metric.value,
          })}
          key={metric.value}
          onClick={(e) => {
            e.stopPropagation();
            handleClick(metric.value);
          }}
        >
          {lang === 'zh' ? metric.label : metric.labelEn}
        </div>
      ))}
    </div>
  );
};
